module.exports = __webpack_public_path__ + "img/100.f559d3d7.jpg";